// Function to remove a cookie by name
export function removeCookie(name, domain) {
  const pastDate = new Date(0);
  document.cookie = `${name}=;expires=${pastDate.toUTCString()};domain=${domain};path=/`;
}

// Example usage
// removeCookie("myCookie", "domain");
